module.exports = __webpack_public_path__ + "img/40_38_061_830.6aa455b5.jpg";